import React, { Component, useContext } from 'react';
import { Row, Col, Popconfirm, Space, Spin, Layout, message, Typography, Card, List } from 'antd'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


import User from "../../../Hooks/Logged";
import usePermissions from "../../../Hooks/usePermissions";
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";
import PageHeader from '../../Widgets/PageHeader/PageHeader';

import ModalSizes from './ModalSizes.js'
import { ButtonDelete, ButtonEdit } from '../../Widgets/Buttons';
import useSearch from '../../../Hooks/useSearch';
import { getResponseError } from '../../Utils'

const { Content } = Layout;
const { Text } = Typography;
/**
 *
 *
 * @export
 * @class Sizes
 * @extends {Component}
 * @description Vista de Project Manager
 */
class Sizes extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalVisible: false,
            size_id: undefined,

            sizes: {
                data: [],
                limit: 10,
                page: 1,

                total: 0,
                pages: 0,

            }
        }
    }

    componentDidMount() {
        this.props.setShowSearch(true)
        this.get();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            this.get({ page: 1 })
        }
    }
    componentWillUnmount() {
        this.props.setShowSearch(false)
    }


    /**
    * @memberof Sizes
    * @method get
    * @description Trae las sizes 
    * 
    */
    get = ({
        page = this.state.sizes.page,
        limit = this.state.sizes.limit,

        search = this.props.search

    } = this.state.sizes) => {
        this.setState({ loading: true, sizes: { ...this.state.sizes, page, limit } })
        axios.get('/sizes', {
            params: { page, limit, search }
        }).then(({ data }) => {
            this.setState({ sizes: data })
        }).catch(error => {
            message.error('Error al obtener la Información')
        }).finally(() => this.setState({ loading: false }))
    }

    render() {

        const { sizes } = this.state

        return (
            <>
                <Spin spinning={false}>
                    <PageHeader
                        className="admin-page-header"
                        title="Tamaños"
                    />

                    <Content className="admin-content content-bg pd-1">
                        <List
                            loading={this.state.loading}
                            className="component-list"
                            itemLayout="horizontal"
                            locale={{ emptyText: "Tamaños sin registros" }}
                            dataSource={sizes.data}
                            pagination={{
                                current: sizes.page,
                                pageSize: sizes.limit,
                                total: sizes.total,
                                showSizeChanger: true,
                                position: 'bottom',
                                onChange: (page, limit) => {
                                    this.get({ page, limit })
                                }
                            }}
                            header={<Row className="width-100 pr-1 pl-1 component-list-header" >
                                <Col xs={9}>
                                    <Text strong>Nombre</Text>
                                </Col>
                                <Col xs={12}>
                                    <Text strong>Descripción</Text>
                                </Col>
                            </Row>
                            }

                            renderItem={item => (
                                <List.Item className="component-list-item">
                                    <Card className="card-list">
                                        <Row className="width-100" gutter={[6, 8]}>
                                            <Col xs={9}>
                                                <Text strong>{item.nombre}</Text>
                                            </Col>
                                            <Col xs={12}>
                                                <Text ellipsis>{item.descripcion}</Text>
                                            </Col>
                                            <Col xs={3} className="center">
                                                <Space>
                                                    <ButtonEdit
                                                        disabled={!this.props.editarSizes}
                                                        title="Editar"
                                                        onClick={() => { this.setState({ modalVisible: true, size_id: item._id }) }}
                                                    />
                                                    <ButtonDelete
                                                        disabled={!this.props.deleteSizes}
                                                        onConfirm={() => axios.delete('/sizes', {
                                                            params: {
                                                                id: item._id
                                                            }
                                                        }).then(() => {
                                                            this.get()
                                                            message.success("Eliminado correctamente")
                                                        }).catch(e => message.error(getResponseError(e.response, 'Error al eliminar el tamaño')))}
                                                        title="Eliminar"
                                                    />


                                                </Space>
                                            </Col>
                                        </Row>
                                    </Card>
                                </List.Item>
                            )}
                        />


                    </Content>

                    { this.props.createSizes &&  <FloatingButton title="New register" onClick={() => this.setState({ modalVisible: true })} /> }


                </Spin>
                <ModalSizes
                    visible={this.state.modalVisible}
                    onClose={() => {
                        this.setState({ modalVisible: false, size_id: undefined })
                        this.get()
                    }}
                    size_id={this.state.size_id}
                />
            </>
        )

    }
}

export default function Vista(props) {

    const { search, setShow } = useSearch()
    const user = useContext(User);

    const permisos = usePermissions(user?.rol_id?.permisos, {
        editarSizes: ["sizes", "edit"],
        deleteSizes: ["sizes", "delete"],
        createSizes: ["sizes", "create"]

    });

    return <Sizes {...props} search={search} setShowSearch={setShow} navigate={useNavigate()} {...permisos} />

}